// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3pa3O","header":"Messages_header__C-ZDh"};